import {ToolTip} from "@/components/responsive/product/tooltip/Tooltip";
import React, {FunctionComponent} from "react";


interface Props {
    isWebOnly: boolean,
}

export const BUTSeller: FunctionComponent<Props> = ({isWebOnly}) => {
    return (
        <>
            <p>
                Vendu par <span className="BUT-seller"> BUT</span>
            </p>
            {isWebOnly && (
                <div className="web-only">
                    <p className="text"> - Exclu WEB</p>
                    <ToolTip label="Les produits exclu web ne sont pas exposés en magasin"/>
                </div>
            )}
        </>
    );
}